import * as HTML_RENDITION from '../utils/general/general';
import _ from 'lodash';

export const cv_getHref = (linkType: string, url: string) => {
    let linkUrl = url;
    if (linkType && !_.isEmpty(linkType) && 'document_html' === linkType) {
        linkUrl = HTML_RENDITION.addParentDocDataParam(url);
    }
    if (/^mailto:/.test(linkUrl)) {
        return linkUrl;
    } else if (HTML_RENDITION.isCVLink(linkUrl)) {
        return 'cvopendoc:' + linkUrl;
    } else {
        // C163778-9854: [CV App IOS] "Failed to download" error pops up when clicking link on HTML rendition.
        // Discussed with zl56189 from CV mobile team, all the non CV link will open external browser to execute.
        return 'cvopenexternallink:' + linkUrl;
    }
};
